import { render, staticRenderFns } from "./EmploymentOvertimeAllowancesTable.vue?vue&type=template&id=169b4706"
import script from "./EmploymentOvertimeAllowancesTable.vue?vue&type=script&lang=js"
export * from "./EmploymentOvertimeAllowancesTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports